import React, { useContext } from 'react'
import { Grid, Separator, Toggle, useContainerWidth } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { WidthContext } from '@fs/zion-ui/quarks-authorized-use-only'
import SectionCardSkeleton from '../../components/section-card/SectionCardSkeleton'
import FamilyColumnSkeleton from '../../components/family-members/family-column/FamilyColumnSkeleton'
import FamilyColumnProvider from '../../contexts/FamilyColumnContext'

type Props = {
  isSingleCardPage?: boolean
  totalColumns?: number
}

export default function FamilyMembersCardSkeleton({ isSingleCardPage = true, totalColumns = 12 }: Props): JSX.Element {
  const [t] = useTranslation()
  const containerWidth = useContext<number>(WidthContext)
  const isMobile = containerWidth < 572
  const atWidth = useContainerWidth()
  const columnWidth = isMobile ? totalColumns : totalColumns / 2

  return (
    <Grid gutters="nano">
      <SectionCardSkeleton isSingleCardPage={isSingleCardPage} heading={t('tree-person.family-members.label')}>
        <Toggle
          aria-label={t('tree-person.show-all-children.label')}
          data-testid="show-all-children-toggle"
          label={t('tree-person.show-all-family-members.action')}
          disabled
        />
        <Grid gutters={atWidth({ default: 'xxs', lg: 'sm' })}>
          <Grid columns={columnWidth}>
            <FamilyColumnProvider type="spouses" showPreferred={false}>
              <FamilyColumnSkeleton />
            </FamilyColumnProvider>
          </Grid>
          {isMobile && <Separator size="xxs" />}
          <Grid columns={columnWidth}>
            <FamilyColumnProvider type="parents" showPreferred={false}>
              <FamilyColumnSkeleton />
            </FamilyColumnProvider>
          </Grid>
        </Grid>
      </SectionCardSkeleton>
    </Grid>
  )
}
